module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-104.d62b99ce.svg";